
    import * as React from 'react';

    const Adjust24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M12.0003 4.80005L7.68031 10.56H16.3203L12.0003 4.80005Z" /><mask id="Adjust_24_svg__mask0" style={{
    maskType: "alpha"
  }} maskUnits="userSpaceOnUse" x={7} y={4} width={10} height={7}><path fillRule="evenodd" clipRule="evenodd" d="M12.0003 4.80005L7.68031 10.56H16.3203L12.0003 4.80005Z" fill="white" /></mask><g mask="url(#Adjust_24_svg__mask0)" /><path fillRule="evenodd" clipRule="evenodd" d="M11.9997 19.2L16.3197 13.44H7.67969L11.9997 19.2Z" /><mask id="Adjust_24_svg__mask1" style={{
    maskType: "alpha"
  }} maskUnits="userSpaceOnUse" x={7} y={13} width={10} height={7}><path fillRule="evenodd" clipRule="evenodd" d="M11.9997 19.2L16.3197 13.44H7.67969L11.9997 19.2Z" fill="white" /></mask><g mask="url(#Adjust_24_svg__mask1)" /></svg>
        </div>
      );
    };

    Adjust24.displayName = 'Adjust24';

    export default Adjust24;
  